module.exports = __webpack_public_path__ + "img/heart-fill1.d975d348.svg";